import { render, staticRenderFns } from "./SpcmCalenderEditV1.vue?vue&type=template&id=ddcede5c"
import script from "./SpcmCalenderEditV1.vue?vue&type=script&lang=js"
export * from "./SpcmCalenderEditV1.vue?vue&type=script&lang=js"
import style0 from "./SpcmCalenderEditV1.vue?vue&type=style&index=0&id=ddcede5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports